import { API } from "@/lib/api";

export const fetchDisabilityPensionTypeList = async (): Promise<string[]> => {
  const response = await fetch(API.DisabilityPensionTypes, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(
      errorData.message || `HTTP error! status: ${response.status}`,
    );
  }

  return response.json();
};
